import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const assetMgmtRoute = createRoute({
    path: "/asset",
    name: "asset.",
    icon: "hourglass_top",
    accCode: "management_aset",
    exclude_breadcrumbs: true,
});

export const amAddRoute = createRoute({
    path: `${assetMgmtRoute.path}/create`,
    name: "asset.create",
    accCode: "management_aset_create",
    parentCode: assetMgmtRoute.accCode,
});

export const amListRoute = createRoute({
    path: `${assetMgmtRoute.path}/list`,
    name: "asset.list",
    accCode: "management_aset_list",
    parentCode: assetMgmtRoute.accCode,
});

export const amHistoryRoute = createRoute({
    path: `${assetMgmtRoute.path}/history`,
    name: "asset.history",
    accCode: "management_aset_history",
    parentCode: assetMgmtRoute.accCode,
});

// component
const AssetManagement = lazy(() => import("../page/asset_management/AssetManagement"));

export const assetMgmtListRoutes = [amAddRoute, amListRoute, amHistoryRoute];

export const assetMgmtRoutes = {
    element: <AssetManagement />,
    children: addHandleRoute([
        { ...amAddRoute, element: <></> },
        { ...amListRoute, element: <></> },
        { ...amHistoryRoute, element: <></> },
    ]),
};

